import { doc, setDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { firestore } from '../../firebase';

// Utility function to assign superadmin role to a user
export const assignSuperAdminRole = async (email) => {
  try {
    // Check if user already exists
    const userQuery = query(
      collection(firestore, 'UserProfileMaster'),
      where('email', '==', email)
    );
    const userSnapshot = await getDocs(userQuery);
    
    if (!userSnapshot.empty) {
      // User exists, update their role to superadmin
      const userDoc = userSnapshot.docs[0];
      await setDoc(doc(firestore, 'UserProfileMaster', userDoc.id), {
        ...userDoc.data(),
        role: 'superadmin',
        updatedAt: new Date()
      }, { merge: true });
      console.log(`User ${email} has been assigned superadmin role`);
      return { success: true, message: 'User role updated to superadmin' };
    } else {
      // User doesn't exist, create new superadmin user
      const newUserRef = doc(collection(firestore, 'UserProfileMaster'));
      await setDoc(newUserRef, {
        email: email,
        role: 'superadmin',
        displayName: 'Super Admin',
        createdAt: new Date(),
        updatedAt: new Date()
      });
      console.log(`New superadmin user created for ${email}`);
      return { success: true, message: 'New superadmin user created' };
    }
  } catch (error) {
    console.error('Error assigning superadmin role:', error);
    return { success: false, message: 'Error assigning superadmin role', error };
  }
};

// Utility function to check user role
export const checkUserRole = async (email) => {
  try {
    const userQuery = query(
      collection(firestore, 'UserProfileMaster'),
      where('email', '==', email)
    );
    const userSnapshot = await getDocs(userQuery);
    
    if (!userSnapshot.empty) {
      const userData = userSnapshot.docs[0].data();
      return { 
        exists: true, 
        role: userData.role,
        userData: userData
      };
    } else {
      return { exists: false, role: null };
    }
  } catch (error) {
    console.error('Error checking user role:', error);
    return { exists: false, role: null, error };
  }
};

// Utility function to list all superadmins
export const listSuperAdmins = async () => {
  try {
    const superAdminQuery = query(
      collection(firestore, 'UserProfileMaster'),
      where('role', '==', 'superadmin')
    );
    const superAdminSnapshot = await getDocs(superAdminQuery);
    
    const superAdmins = superAdminSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    
    return { success: true, superAdmins };
  } catch (error) {
    console.error('Error listing superadmins:', error);
    return { success: false, error };
  }
};
